import { useQuery } from 'react-query'
import { getFriendGroupById } from '@services/requests/friendGroups'

export const useGetFriendGroup = (friendGroupId?: string) => {
  return useQuery(['friends.info', friendGroupId], () => {
    if (!friendGroupId) return undefined
    return getFriendGroupById(friendGroupId)
  })
}
